import mixpanel from 'mixpanel-browser';

export const TrackEventService = (eventName, data = {}) => {
  try {
    const sessionStr = localStorage.getItem('session');
    const user = sessionStr ? JSON.parse(sessionStr) : {};

    const defaultData = {
      url: window.location.href,
      timestamp: new Date().toISOString(),
      user_id: user.userName || 'guest',
      user_name: user.fullName || 'guest',
      email: user.email || 'guest email',
      event: eventName || 'event',
    };

    mixpanel.track(eventName, { ...defaultData, ...data });
  } catch (error) {
    console.error('Mixpanel tracking failed:', error);
  }
};
